import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const uploadFile = async (url, file) => fetchOk(url, {
  method: 'POST',
  body: file
}).then(response => response.json());